// extracted by mini-css-extract-plugin
export default {"flexWrapper":"loadMoreButton_flexWrapper__04Q2i","primary":"loadMoreButton_primary__fUy7L","iconFill":"loadMoreButton_iconFill__y27Jr","border":"loadMoreButton_border__6Q+1j"};